var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3829 16.382H13.6952V12.175C13.6952 11.1721 13.6771 9.88219 12.2975 9.88219C10.8998 9.88219 10.6863 10.9757 10.6863 12.1035V16.382H8.0006V7.73236H10.5765V8.91451H10.6138C10.9733 8.23483 11.8494 7.51788 13.1574 7.51788C15.8804 7.51788 16.3829 9.30823 16.3829 11.6383V16.382ZM4.96953 6.55122C4.10552 6.55122 3.40868 5.8524 3.40868 4.99146C3.40868 4.13153 4.10552 3.43271 4.96953 3.43271C5.8285 3.43271 6.52736 4.13153 6.52736 4.99146C6.52736 5.8524 5.8285 6.55122 4.96953 6.55122ZM3.62216 16.382H6.31388V7.73236H3.62216V16.382ZM17.7212 0.9375H2.27379C1.53667 0.9375 0.9375 1.52253 0.9375 2.24451V17.7545C0.9375 18.4765 1.53667 19.0625 2.27379 19.0625H17.7212C18.4603 19.0625 19.0625 18.4765 19.0625 17.7545V2.24451C19.0625 1.52253 18.4603 0.9375 17.7212 0.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.15d3754a7945fd2062450fb2c4b1b3b0.svg";
export { ForwardRef as ReactComponent };